import { observer } from 'mobx-react';
import { ExperienceResource } from '../../../../../../Types';
import LockIcon from '../../../../../../../Cutesies/LockIcon';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  experienceResource: ExperienceResource;
}

function HighlightUnlicensed({ experienceResource }: Props) {
  switch (experienceResource.payload.status) {
    case 'Licensed':
      return emptyFragment();
    case 'Unlicensed':
      return (
        <div className="bg-white rounded-full p-1">
          <LockIcon />
        </div>
      );
  }
}

export default observer(HighlightUnlicensed);
